import { ChangeDetectionStrategy, Component, HostBinding, OnInit, inject } from '@angular/core';
import { Observable, catchError, combineLatest, of, shareReplay, switchMap, tap } from 'rxjs';
import { PanelService } from 'src/app/dashboards/panels/services/panel/panel.service';
import { waitUntilVisible } from 'src/app/panels/directives/visible/visible.directive';
import { DisplayUnit } from 'src/app/panels/models/display-unit';
import { IPowerLimitsKpiValue } from 'src/app/panels/models/kpi-value';
import { PanelType } from 'src/app/panels/models/panel-type';
import { ColorService } from '../../../../../shared/services/color/color.service';
import { Color } from '../../../../../shared/services/color/colors';
import { KPI_PANEL_IMPORTS } from '../../../../../panels/components/kpi/kpi-panel/kpi-panel.component';
import { PanelComponent } from '../../../../../panels/components/panel.component';

@PanelComponent.register
@Component({
  selector: 'app-power-limits-kpi-panel',
  templateUrl: '../power-limits-kpi-panel/power-limits-kpi-panel.component.html',
  styleUrl: '../power-limits-kpi-panel/power-limits-kpi-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: KPI_PANEL_IMPORTS,
})
export class PowerLimitsKpiPanelComponent extends PanelComponent implements OnInit {
  public static override readonly type = PanelType.PowerLimitsKpi;
  @HostBinding('class') public class = 'col-12 col-sm-6 col-lg-4 col-xl-3';

  public override title = 'Contractvermogen';
  public override icon = 'bi-lightning-charge-fill';
  public unit = DisplayUnit.Kw;
  public color = Color.DarkBlue;
  public colorService = inject(ColorService);
  public maxConsumedPowerLimit: number | null = null;
  public maxReturnedPowerLimit: number | null = null;
  public override data$?: Observable<IPowerLimitsKpiValue | null>;

  private panelService = inject(PanelService);

  ngOnInit(): void {
    this.data$ = combineLatest([this.dashboardParams$, this.visible$]).pipe(
      waitUntilVisible(this),
      switchMap((params) => {
        return this.panelService.getPowerLimitsKpi(this.entityIds, params.timeRange.from, params.timeRange.till).pipe(
          catchError(() => {
            this.error = 'Geen data';
            return of(null);
          }),
        );
      }),
      tap((data) => {
        this.maxConsumedPowerLimit = data?.kpis.kpi.maxConsumedPowerLimit ?? null;
        this.maxReturnedPowerLimit = data?.kpis.kpi.maxReturnedPowerLimit ?? null;
        this.loading = false;
      }),
      shareReplay(1),
    );
  }
}
